export const formatPrice = (
    price: number,
    currency?: string,
    discounted?: boolean
): string => {
    const amount = price;

    if (!currency || discounted) {
        return amount % 1 === 0 ? amount.toFixed(0) : amount.toFixed(2);
    }

    try {
        // Strip whitespace so locales that emit "14 €" render as "14€" —
        // compact form matches the design system and avoids Weglot latching
        // onto the currency token as a standalone word.
        return new Intl.NumberFormat(undefined, {
            style: "currency",
            currency,
            currencyDisplay: "narrowSymbol",
            minimumFractionDigits: 0,
        })
            .format(amount)
            .replace(/\s/g, "");
    } catch {
        // Fallback if currency code is invalid
        return amount % 1 === 0 ? amount.toFixed(0) : amount.toFixed(2);
    }
};

export const formatPriceCents = (
    priceInCents: number,
    currency?: string
): string => {
    const price = priceInCents / 100;
    return formatPrice(price, currency);
};
